export const SET_LEARNING_ELEMENT = 'cat-proficiency/SET_LEARNING_ELEMENT';
export const RESET_LEARNING_ELEMENT = 'cat-proficiency/RESET_LEARNING_ELEMENT';
export const SET_DOMAIN = 'cat-proficiency/SET_DOMAIN';
export const SET_DOMAIN_PROFICIENCY_RANK = 'cat-proficiency/SET_DOMAIN_PROFICIENCY_RANK';
export const RESET_DOMAIN_PROFICIENCY_RANK = 'cat-proficiency/RESET_DOMAIN_PROFICIENCY_RANK';



// WEBPACK FOOTER //
// ./src/app/cat-proficiency/store/mutation-types.js